import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { api } from "@api/api";
import { ApiError } from "@shared/types";
import { PartnerReferral } from "@modules/partners/types";

import { listReferralsQueryKey } from "../createReferral/mutation";

export function useApproveReferralMutation() {
  const translate = useTranslate();
  const { open } = useNotification();
  const queryClient = useQueryClient();

  return useMutation<PartnerReferral, ApiError, number>({
    mutationFn: async (id) => {
      const { data } = await api.post<PartnerReferral>(
        `/v1/partner_referral_admin/${id}/approve/`
      );
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: listReferralsQueryKey,
        refetchType: "all",
      });
      open?.({ type: "success", message: translate("v1/partner_referral_admin.success.approve") });
    },
    onError: (error: ApiError) => {
      open?.({ type: "error", message: error.response.data.error });
    },
  });
}
